import { Box, Text } from '@wix/design-system';
import { MediaDevices } from 'enums';
import { useBreakpoint } from 'providers/BreakpointProvider';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import SslIcon from '../../assets/images/page-footer/ssl-icon.svg';

const ICON_SIZE_DESKTOP = {
  width: '28px',
  height: '35px',
  flexShrink: 0,
} as const;
const ICON_SIZE_MOBILE = {
  width: '20px',
  height: '20px',
  flexShrink: 0,
} as const;

export const SSLSecurePayment: React.FC = () => {
  const { t } = useTranslation();
  const { currentBreakpoint } = useBreakpoint();
  const isMobile = currentBreakpoint === MediaDevices.Mobile;
  const iconSize = isMobile ? ICON_SIZE_MOBILE : ICON_SIZE_DESKTOP;
  const titleKey = isMobile
    ? 'page_footer.ssl_secure_payment.tablet'
    : 'page_footer.ssl_secure_payment';

  return (
    <Box
      direction={isMobile ? 'vertical' : 'horizontal'}
      align={isMobile ? 'center' : undefined}
      dataHook='ssl-secure-payment'
      verticalAlign={isMobile ? undefined : 'middle'}
      gap={isMobile ? 'SP1' : 'SP3'}
    >
      <Box
        direction='horizontal'
        verticalAlign='middle'
        gap={isMobile ? 'SP1' : 'SP3'}
      >
        <Box {...iconSize}>
          <SslIcon width='100%' height='100%' />
        </Box>
        <Box direction='vertical'>
          <Text weight='bold' size='tiny' tagName={isMobile ? undefined : 'p'}>
            {t(titleKey)}
          </Text>
          {!isMobile && (
            <Box marginTop='10px'>
              <Text weight='thin' size='tiny'>
                {t('page_footer.information_encryption')}
              </Text>
            </Box>
          )}
        </Box>
      </Box>
      {isMobile && (
        <Box textAlign='center'>
          <Text weight='thin' size='tiny'>
            {t('page_footer.information_encryption')}
          </Text>
        </Box>
      )}
    </Box>
  );
};
